import { createSharedComposable } from '@vueuse/core'
import { ref, computed } from 'vue'
import type { AgentInitData, EventData } from '@/types/ai/event'
import { SSE_EVENT_TYPE } from '@/types/ai/event'
import type { Agent } from '@/types/ai/base'

export const useInitData = createSharedComposable(() => {
    const initData = ref<AgentInitData | null>(null)

    /**
     * 如果是主输入框智能规划，则不会有agent信息
     */
    const currentAgent = computed(() => {
        return initData.value?.content
    })

    function reset() {
        initData.value = null
    }

    function setInitAgentData(content: Agent) {
        initData.value = {
            ...initData.value,
            content: {
                ...initData.value?.content,
                ...content,
            },
        }
    }

    function setInitData(data: AgentInitData) {
        initData.value = {
            ...data,
            content: {
                ...initData.value?.content,
                ...data.content,
            },
        }
    }

    function onMessage(data: EventData) {
        if (data.type === SSE_EVENT_TYPE.AGENT_INIT) {
            setInitData(data)
        }
    }

    return {
        initData,
        reset,
        setInitData,
        onMessage,
        currentAgent,
        setInitAgentData,
    }
})
